import { useDispatch, useSelector } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, TotalAmount, TotalAmountCount, TotalPayAmount } from './component/btn/btn';
import List from './component/list/list';
import { LoadingModal } from './component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDateSplit, SearchRange, SearchSelect, SearchSelectText, SearchBtn } from './component/search/search';
import { useLocation, useNavigate } from 'react-router-dom';
import { changeNum, convertDateFormat, convertDate, datePickerCommonOpts, paintWeekendColors } from './common/function';
import moment from 'moment';
import dayjs from 'dayjs';

import Select, { components } from "react-select";
import html2canvas from 'html2canvas';
import domtoimage from 'dom-to-image-more';

import useWindowSize from './hook/useWindowSize'

function Paylist() {
    let dispatch = useDispatch()
    let navigate = useNavigate();

    let MyData = useSelector((state) => { return state.MyData })
    let total_search = useSelector((state) => { return state.total_search.value })

    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(40)
    const [loading, setLoading] = useState(true)
    const [searchModal, setSearchModal] = useState(false)
    const [spinner, setSpinner] = useState(false)

    const [listData, setListData] = useState([])
    const [listTrxData, setListTrxData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [clickData, setClickData] = useState(null)
    const pgTooltipRef = useRef(null)
    const [reload, setReload] = useState(false)
    const [message, setMessage] = useState("")

    const [listState, setListState] = useState(false)
    const [modal1, setModal1] = useState(false)
    const [hasMore, setHasMore] = useState(true)

    const { Rwidth, Rheight } = useWindowSize();

    useEffect(() => {
        setPage(1)
        setLoading(true)
        dispatch(change_Current_Location("거래내역"))
        dispatch(changeHeaderTitle({
            mainTitle: "거래조회"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    const [pgSelect, setPGSelect] = useState(0)
    const [k1psChecked, setK1psChecked] = useState(true);
    const [wGlobalChecked, setWGlobalChecked] = useState(true);

    const handleK1psChange = (e) => {
        setK1psChecked(e.target.checked);
    };

    const handleWGlobalChange = (e) => {
        setWGlobalChecked(e.target.checked);
    };

    useEffect(() => {
        if (k1psChecked && wGlobalChecked) {
            setPGSelect(0);
        }
        else if (k1psChecked && !wGlobalChecked) {
            setPGSelect(1);
        }
        else if (!k1psChecked && wGlobalChecked) {
            setPGSelect(2);
        }
        else {
            setK1psChecked(true);
        }
    }, [k1psChecked, wGlobalChecked]);

    const handleChange = (event) => {
        setPage(1)
        setMaxFirstPage(Number(event.target.value));
    };

    // 기간 포맷 - 시작일/종료일 개별 선택
    const startInputRef = useRef(null);
    const endInputRef = useRef(null);
    const startPickerRef = useRef(null);
    const endPickerRef = useRef(null);

    useEffect(() => {
        startPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: startInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => {
                    setPage(1)
                    setPreDate(date.format('YYYY-MM-DD'));
                });
            }
        });

        endPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: endInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => {
                    setPage(1)
                    setNextDate(date.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            startPickerRef.current?.destroy();
            endPickerRef.current?.destroy();
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수 (당일/전일/당월/전월 버튼에서 호출)
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        startPickerRef.current?.setDate(startDate);
        endPickerRef.current?.setDate(endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setClickData(null)
        setReload(e => !e)
    }

    // 검색구분 포맷 (API searchType enum)
    const select4 = [
        { value: '',         label: '검색조건 선택' },
        { value: 'appId',    label: '승인번호' },
        { value: 'merchant', label: '가맹점명' },
        { value: 'mid',      label: '가맹점 ID' },
        { value: 'agent',    label: '영업자' },
        { value: 'tid',      label: '단말기(TID)' },
        { value: 'card',     label: '카드사' },
    ];

    const [selectedValue3, setSelectedValue3] = useState("appId");
    const [selectedText3, setSelectText3] = useState(total_search)

    useEffect(() => {
        setSelectText3(total_search)
    }, [total_search])

    const handleSelectChange3 = (event) => {
        const value = event.target.value;
        setSelectedValue3(value);
    };

    const handleSelectTextChange3 = (event) => {
        const value = event.target.value;
        setSelectText3(value);
    };

    const [formData, setFormData] = useState({
        조회기준: '1',
        거래상태: '',
        결제구분: '',
        에이전트명: '',
        에이전트아이디: '',
        상호: '',
        MID: '',
        구매자명: '',
        주문번호: '',
        상품명: '',
        연락처: '',
        승인번호: '',
        TID: ''
    });

    const handleChangeFormData = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // 결제수단 필터 (단말기/수기)
    const [terminalChecked, setTerminalChecked] = useState(true);
    const [manualChecked, setManualChecked] = useState(true);
    const paymentType =
        terminalChecked && manualChecked ? "" :
        terminalChecked ? "단말기" :
        manualChecked ? "수기" : "없음";

    const togglePaymentType = (kind) => {
        if (kind === "단말기") setTerminalChecked(v => !v);
        else setManualChecked(v => !v);
        setPage(1);
    };

    useEffect(() => {
        if (pgSelect > -1) {
            ListData()
        }
    }, [reload, pgSelect, page, maxFirstPage, preDate, nextDate, paymentType])

    const ListData = async () => {
        if (page === 1) setSpinner(true)
        await axios.get(process.env.REACT_APP_API + "/api/trx", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                pg: pgSelect === 0 ? "" : pgSelect === 1 ? "K" : "O",
                startDate: preDate,
                endDate: nextDate,
                paymentType,
                ...(selectedValue3 && selectedText3
                    ? { searchType: selectedValue3, searchKeyword: selectedText3 }
                    : {}),
            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                console.log(tmp)
                const trx = tmp?.data?.trx ?? []
                setListData(tmp?.data ?? [])
                if (page === 1) {
                    setListTrxData(trx);
                }
                else {
                    setListTrxData((prev) => [...prev, ...trx]);
                }
                setHasMore(trx.length >= maxFirstPage)
                setListState(e => !e)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setSpinner(false)
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData = MyData?.role == "SUPER" ?
        [
            // { "no": 1, "text": "NO", "width": "70px", "textAlign": "center" },
            { "no": 5, "text": "승인일/취소일", "width": "100px", "textAlign": "center" },
            { "no": 4, "text": "승인번호", "width": "80px", "textAlign": "center" },
            { "no": 2, "text": "가맹점명", "width": "150px", "textAlign": "center" },
            // { "no": 3, "text": "MID", "width": "90px", "textAlign": "center" },
            // { "no": 4, "text": "TID", "width": "90px", "textAlign": "center" },
            // { "no": 6, "text": "취소일", "width": "100px", "textAlign": "center" },
            { "no": 7, "text": "거래금액", "width": "90px", "textAlign": "center" },
            { "no": 8, "text": "결제구분", "width": "70px", "textAlign": "center" },
            // { "no": 9, "text": "카드", "width": "50px", "textAlign": "center" },
            // { "no": 10, "text": "할부", "width": "60px", "textAlign": "center" },
            // { "no": 11, "text": "상품명", "width": "80px", "textAlign": "center" },
            // { "no": 12, "text": "거래상세", "width": "80px", "textAlign": "center" },
            // { "no": 13, "text": "거래확인서", "width": "80px", "textAlign": "center" },
            { "no": 14, "text": (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "2px" }}>
                    <span>PG</span>
                    <span
                        onMouseEnter={(e) => { if (pgTooltipRef.current) { pgTooltipRef.current.style.display = "block"; pgTooltipRef.current.style.top = (e.clientY + 10) + "px"; pgTooltipRef.current.style.left = (e.clientX + 10) + "px"; } }}
                        onMouseLeave={() => { if (pgTooltipRef.current) pgTooltipRef.current.style.display = "none"; }}
                        style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "14px", height: "14px", borderRadius: "50%", background: "#ccc", color: "#fff", fontSize: "10px", fontWeight: "bold", cursor: "pointer" }}>?</span>
                </div>
            ), "width": "50px", "textAlign": "center" },
            { "no": 16, "text": "정산", "width": "50px", "textAlign": "center" },
        ]
        :
        [
            { "no": 13, "text": "전표", "width": "50px", "textAlign": "center" },
            { "no": 5, "text": "승인일/취소일", "width": "100px", "textAlign": "center" },
            { "no": 7, "text": "거래금액", "width": "90px", "textAlign": "center" },
            // { "no": 15, "text": "수당", "width": "100px", "textAlign": "center" },
            // { "no": 4, "text": "승인번호", "width": "80px", "textAlign": "center" },
            { "no": 9, "text": "카드번호", "width": "110px", "textAlign": "center" },
            { "no": 2, "text": "가맹점명", "width": "150px", "textAlign": "center" },
            { "no": 10, "text": "할부", "width": "60px", "textAlign": "center" },
            // { "no": 16, "text": "구분", "width": "50px", "textAlign": "center" },
            { "no": 17, "text": "출금여부", "width": "70px", "textAlign": "center" },
            // { "no": 8, "text": "결제구분", "width": "80px", "textAlign": "center" },
            // { "no": 1, "text": "NO", "width": "70px", "textAlign": "center" },
            // { "no": 3, "text": "MID", "width": "90px", "textAlign": "center" },
            // { "no": 4, "text": "TID", "width": "90px", "textAlign": "center" },
            // { "no": 6, "text": "취소일", "width": "100px", "textAlign": "center" },
            // { "no": 11, "text": "상품명", "width": "80px", "textAlign": "center" },
            // { "no": 12, "text": "거래상세", "width": "80px", "textAlign": "center" },
            // { "no": 14, "text": "상단", "width": "70px", "textAlign": "center" },
        ]

    useEffect(() => {
        let tableBodyData = [];
        if (listTrxData) {
            let list = listTrxData ?? []
            for (let i = 0; i < list.length; i++) {
                let data = list[i]

                let rowData = MyData?.role == "SUPER" ?
                    [
                        // { "no": 1, "text": data.id, "width": "70px", "textAlign": "center" },
                        { "no": 5, "text": data?.cancel_date ? convertDateFormat(data.cancel_date) : convertDateFormat(data.trx_date), "width": "100px", "textAlign": "center" },
                        { "no": 4, "text": data.approval_id, "width": "80px", "textAlign": "center" },
                        { "no": 2, "text": data.merchant_nm, "width": "150px", "textAlign": "left" },
                        // { "no": 3, "text": data.mid, "width": "90px", "textAlign": "center" },
                        // { "no": 4, "text": data.terminal_id, "width": "90px", "textAlign": "center" },
                        // {
                        //     "no": 6,
                        //     "text": data.cancel_date ? convertDateFormat(data.cancel_date) : '',
                        //     "width": "100px",
                        //     "textAlign": "center"
                        // },
                        { "no": 7, "text": `${changeNum(data.amt)}원`, "width": "90px", "textAlign": "right" },
                        { "no": 8, "text": data.payment_type, "width": "70px", "textAlign": "center" },
                        // { "no": 9, "text": data.card.slice(0, 2), "width": "50px", "textAlign": "center" },
                        // { "no": 10, "text": data.quota === "00" ? "일시불" : `${Number(data.quota)}개월`, "width": "60px", "textAlign": "center" },
                        // { "no": 11, "text": data.prd_nm, "width": "80px", "textAlign": "center" },
                        // {
                        //     "no": 12,
                        //     "text": (
                        //         <div className='pointer list-text-center' onClick={() => { setClickData(data); setModal(true) }}>
                        //             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        //                 viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                        //                 strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-archive w-4 h-4"
                        //                 style={{ color: "#0064ff" }}>
                        //                 <path d="M20 9v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9m16-5H4a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-10 9h4"></path>
                        //             </svg>
                        //         </div>
                        //     ),
                        //     "width": "80px",
                        //     "textAlign": "center"
                        // },
                        // {
                        //     "no": 13,
                        //     "text": (
                        //         <div className='pointer list-text-center' onClick={() => { setClickData(data); setModal1(true) }}>
                        //             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        //                 viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                        //                 strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-clipboard w-4 h-4"
                        //                 style={{ color: "#0a6e0a" }}>
                        //                 <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                        //                 <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                        //             </svg>
                        //         </div>
                        //     ),
                        //     "width": "80px",
                        //     "textAlign": "center"
                        // },
                        { "no": 14, "text": (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                title={(data.pg === "DAOU_PN" || data.pg === "O") ? "윈글로벌" : data.pg === "weroute" ? "위루트" : data.pg === "wizzpay" ? "위즈페이" : data.pg}>
                                <span style={{
                                    display: "inline-block", width: "12px", height: "12px", borderRadius: "50%",
                                    background: (data.pg === "DAOU_PN" || data.pg === "O") ? "#eab308" : data.pg === "weroute" ? "#3b82f6" : data.pg === "wizzpay" ? "#f59e0b" : "#999"
                                }} />
                            </div>
                        ), "width": "50px", "textAlign": "center" },
                        { "no": 16, "text": (<span style={{ color: data.settlement_cycle === "D0" ? "#ef4444" : undefined }}>{data.settlement_cycle === "D0" ? "즉결" : "익일"}</span>), "width": "50px", "textAlign": "center" },
                    ]
                    :
                    [
                        {
                            "no": 13,
                            "text": (
                                <div className='pointer list-text-center' onClick={() => { setClickData(data); setModal1(true) }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                        strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-clipboard w-4 h-4"
                                        style={{ color: "#0a6e0a" }}>
                                        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                                        <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                                    </svg>
                                </div>
                            ),
                            "width": "50px",
                            "textAlign": "center"
                        },
                        { "no": 5, "text": data?.cancel_date ? convertDateFormat(data.cancel_date) : convertDateFormat(data.trx_date), "width": "100px", "textAlign": "center" },
                        // { "no": 4, "text": data.approval_id, "width": "80px", "textAlign": "center" },
                        { "no": 7, "text": `${changeNum(data.amt)}원`, "width": "90px", "textAlign": "right" },
                        // { "no": 15, "text": `${changeNum(data.amt)}원`, "width": "100px", "textAlign": "right" },
                        { "no": 9, "text": data.card_num, "width": "110px", "textAlign": "center" },
                        { "no": 2, "text": data.merchant_nm, "width": "150px", "textAlign": "left" },
                        { "no": 10, "text": data.quota === "00" ? "일시불" : `${Number(data.quota)}개월`, "width": "60px", "textAlign": "center" },
                        // { "no": 16, "text": data.org_settlement_cycle === "D0" ? "즉결" : "익일", "width": "50px", "textAlign": "center" },
                        {
                            "no": 17,
                            "text": (
                                <span style={{ color: data.withdraw_yn === 1 ? "#0a6e0a" : undefined }}>
                                    {data.withdraw_yn === 1 ? "출금" : "-"}
                                </span>
                            ),
                            "width": "70px",
                            "textAlign": "center"
                        },
                        // { "no": 8, "text": data.payment_type, "width": "80px", "textAlign": "center" },
                        // { "no": 1, "text": data.id, "width": "70px", "textAlign": "center" },
                        // { "no": 3, "text": data.mid, "width": "90px", "textAlign": "center" },
                        // { "no": 4, "text": data.terminal_id, "width": "90px", "textAlign": "center" },
                        // {
                        //     "no": 6,
                        //     "text": data.cancel_date ? convertDateFormat(data.cancel_date) : '',
                        //     "width": "100px",
                        //     "textAlign": "center"
                        // },
                        // { "no": 11, "text": data.prd_nm, "width": "80px", "textAlign": "center" },
                        // {
                        //     "no": 12,
                        //     "text": (
                        //         <div className='pointer list-text-center' onClick={() => { setClickData(data); setModal(true) }}>
                        //             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        //                 viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                        //                 strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-archive w-4 h-4"
                        //                 style={{ color: "#0064ff" }}>
                        //                 <path d="M20 9v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9m16-5H4a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-10 9h4"></path>
                        //             </svg>
                        //         </div>
                        //     ),
                        //     "width": "80px",
                        //     "textAlign": "center"
                        // },
                        // { "no": 14, "text": data.pg === "K" ? "K-WON" : "WGP", "width": "70px", "textAlign": "center" },
                    ]

                // ★추가됨: 취소일이 있으면 Listbody에서 색상 처리할 수 있도록 rowData에 저장
                rowData.cancel_date = data.cancel_date; // <-- 추가
                rowData.id = MyData?.role == "SUPER" ? data.id : ""
                rowData.amount = data.amt

                tableBodyData.push(rowData);
            }
            setCombineData(tableBodyData)
        }
    }, [listTrxData])

    const handleRowClick = (row) => {
        const found = listTrxData?.find((d) => d.id == row.id);

        if (found) {
            setClickData(found);
        }
    };

    const excelBtn = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/trx/excel", {
            withCredentials: true,
            params: {
                pg: pgSelect === 0 ? "" : pgSelect === 1 ? "K" : "O",
                startDate: preDate,
                endDate: nextDate,
                paymentType,
                ...(selectedValue3 && selectedText3
                    ? { searchType: selectedValue3, searchKeyword: selectedText3 }
                    : {}),
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                excelData(tmp?.data?.trx ?? [])
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const excelData = (exData) => {
        let arr = []

        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i]

                try {
                    arr.push({
                        "NO": i + 1,
                        "상호": t.co_nm,
                        "MID": t.mid,
                        "승인번호": t.approval_id,
                        "거래일시": t.trx_date,
                        "취소일시": t?.cancel_date ?? "",
                        "거래상태": t.state == '1' ? "승인" : t.status == '2' ? "매입전취소" : "매입후취소",
                        "승인금액": Number(t.amt),
                        "정산수수료": Number(t.fee),
                        "정산금액": Number(t.settlement_amt),
                        // "취소금액": Number(t.cancel_amt),
                        "결제서비스": t.payment_service,
                        "결제구분": t.payment_type,
                        "구매자명": t.buyer_nm,
                        "카드": t.card,
                        "카드번호": t.card_num.slice(-4),
                        "할부": t.quota === "00" ? "일시불" : `${t.quota}개월`,
                        "상품명": t.prd_nm,
                        "거래번호": t.trx_id,
                    })
                } catch (error) {
                    console.log(error);
                }
            }
        }
        Excel(arr)
    }

    // 더보기 버튼
    const [moreBtn, setMoreBtn] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 640) setMoreBtn(true)
            else setMoreBtn(false)
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [])

    // useEffect(() => {
    //     if (listTrxData?.length > 0) {
    //         setClickData(listTrxData[0] ?? []);
    //     } else {
    //         setClickData([]);
    //     }
    // }, [listData]);


    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && hasMore) {
                // 바닥에 닿으면 페이지 증가 (마지막 배치가 limit 미만이면 종료)
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData, hasMore]);

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            {searchModal ? <SearchInfo setModal={setSearchModal} setReload={setReload} formData={formData} handleChangeFormData={handleChangeFormData} /> : ""}
            {modal1 ? <MobileReceiptInfo setModal={setModal1} clickData={clickData} /> : ""}
            <MessageModal message={message} />
            <div
                ref={pgTooltipRef}
                style={{ display: "none", position: "fixed", background: "#333", color: "#fff", padding: "8px 10px", borderRadius: "6px", fontSize: "11px", whiteSpace: "nowrap", zIndex: 9999, lineHeight: "1.8", pointerEvents: "none" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}><span style={{ display: "inline-block", width: "10px", height: "10px", borderRadius: "50%", background: "#eab308" }} />윈글로벌</div>
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}><span style={{ display: "inline-block", width: "10px", height: "10px", borderRadius: "50%", background: "#3b82f6" }} />위루트</div>
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}><span style={{ display: "inline-block", width: "10px", height: "10px", borderRadius: "50%", background: "#ef4444" }} />위즈페이</div>
            </div>

            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDateSplit
                        startInputRef={startInputRef}
                        endInputRef={endInputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={false}
                        state={true}
                    />
                    <SearchSelectText type={"검색구분"} selectData={select4} handleSelectChange={handleSelectChange3} selectedValue={selectedValue3} handleSelectTextChange={handleSelectTextChange3} selectedText={selectedText3} btnText={"검색"} onClick={() => onSubmitSearch()} />

                    {MyData?.role == "SUPER" && (
                        <div className='input-disable' style={{ display: 'flex', gap: '8px', marginTop: '6px' }}>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={terminalChecked}
                                    onChange={() => togglePaymentType("단말기")}
                                    style={{ marginRight: "5px" }}
                                />
                                단말기
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={manualChecked}
                                    onChange={() => togglePaymentType("수기")}
                                    style={{ marginRight: "5px" }}
                                />
                                수기
                            </label>
                        </div>
                    )}

                    {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: "30px" }}>
                        <label>
                            <input
                                type="checkbox"
                                checked={k1psChecked}
                                onChange={handleK1psChange}
                                style={{ marginRight: "5px" }}
                            />
                            <span>케이원피에스</span>
                        </label>

                        <label style={{ marginLeft: '10px' }}>
                            <input
                                type="checkbox"
                                checked={wGlobalChecked}
                                onChange={handleWGlobalChange}
                                style={{ marginRight: "5px" }}
                            />
                            <span>윈글로벌</span>
                        </label>
                    </div> */}

                    {/* <div className="button_wrap" style={{ marginTop: "0" }}>
                        <button onClick={() => setSearchModal(true)} id="tabulator-html-filter-go" name="searchPayBtn" type="button" className="btn btn-primary searchPayBtn" style={{ height: "30px", fontSize: "12px" }}>
                            검색조건<SlidersHorizontal style={{ paddingLeft: "3px" }} />
                        </button>
                    </div> */}
                </form>
                {/* <div className="more_wrap">
                    <button type="button" onClick={() => setMoreBtn(e => !e)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" icon-name="chevron-down"
                            data-lucide="chevron-down" className="lucide lucide-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg><span>더보기</span>
                    </button>
                </div> */}
            </div>
            <div className="intro-y box intro-padding">
                <div className="tabulator_sorting_wrap">
                    <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end', margin: "0", width: "100%", gap: "10px" }}>
                        <TotalAmount
                            confirm_amt={Number(listData?.stateSummary?.find(item => item.state == '1')?.total_amt ?? 0)}
                            confirm_cnt={Number(listData?.stateSummary?.find(item => item.state == '1')?.count ?? 0)}
                            canceled_amt={Number(listData?.stateSummary?.find(item => item.state == '2')?.total_amt ?? 0) + Number(listData?.stateSummary?.find(item => item.state == '3')?.total_amt ?? 0)}
                            canceled_cnt={Number(listData?.stateSummary?.find(item => item.state == '2')?.count ?? 0) + Number(listData?.stateSummary?.find(item => item.state == '3')?.count ?? 0)}
                        />
                        {
                            MyData?.role == "SUPER"
                                ?
                                <TotalPayAmount
                                    instant_terminal_amt={Number(listData?.stateSummary?.find(item => item.state == '1')?.terminal_instant_amt ?? 0) + Number(listData?.stateSummary?.find(item => item.state == '2')?.terminal_instant_amt ?? 0) + Number(listData?.stateSummary?.find(item => item.state == '3')?.terminal_instant_amt ?? 0)}
                                    normal_terminal_amt={Number(listData?.stateSummary?.find(item => item.state == '1')?.terminal_normal_amt ?? 0) + Number(listData?.stateSummary?.find(item => item.state == '2')?.terminal_normal_amt ?? 0) + Number(listData?.stateSummary?.find(item => item.state == '3')?.terminal_normal_amt ?? 0)}
                                    manual_amt={Number(listData?.stateSummary?.find(item => item.state == '1')?.manual_amt ?? 0) + Number(listData?.stateSummary?.find(item => item.state == '2')?.manual_amt ?? 0) + Number(listData?.stateSummary?.find(item => item.state == '3')?.manual_amt ?? 0)}
                                    pgSelect={pgSelect}
                                />
                                :
                                ""
                        }
                    </div>
                    <div className='excel-disable'>
                        <DownloadBtn text={"엑셀 다운로드"} onClick={excelBtn} />
                        {/* <CountSelect onChange={handleChange} maxFirstPage={maxFirstPage} /> */}
                    </div>
                </div>

                <div className='div-flex-1' >
                    <div className='div-flex-1-1' style={{ width: MyData?.role == "SUPER" ? "" : "100%", maxWidth: MyData?.role == "SUPER" ? "600px" : "680px", width: MyData?.role == "SUPER" ? Rwidth >= 1500 ? "600px" : "100%" : "100%" }}>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={listData?.totCnt ?? 0}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            clickData={clickData}
                            onRowClick={handleRowClick}
                            listType={true}
                            listState={listState}
                            observerRef={observerRef}
                            nonePage={false}
                            scrollState={true}
                            height={"820px"}
                            spinner={spinner}
                        />
                    </div>
                    {
                        !clickData && listTrxData?.length > 0 && MyData?.role != 'SM' && (
                            <div className='mt-3 div-flex-1-2' style={{ border: "16px solid rgb(69 69 69)", width: Rwidth >= 1500 ? "1010px" : "100%", height: "880px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px", fontWeight: "bold", color: "gray", textAlign: "center" }}>
                                왼쪽 목록에서 거래를 선택하면<br />
                                세부정보를 확인할 수 있습니다.
                            </div>
                        )
                    }
                    {
                        clickData && MyData?.role == "SUPER"
                            ?
                            <div className='mt-3 div-flex-1-2'
                                style={{
                                    display: "flex", padding: Rwidth >= 640 ? "16px" : "0", backgroundColor: Rwidth >= 640 ? clickData?.id ? "rgb(69 69 69)" : "" : ""
                                    , height: "auto", minWidth: Rwidth >= 1500 ? "1010px" : "auto"
                                }}>
                                <div className='div-flex-1-3' style={{ backgroundColor: "#fff" }}
                                >
                                    <div style={{
                                        display: "flex",
                                        gap: "10px",
                                        alignItems: "center",
                                        padding: "0 10px",
                                        borderBottom: "1px solid #E5E5E5"
                                    }}>
                                        <button
                                            className={`tab-btn active`}
                                            style={{
                                                padding: "12px 10px 8px",
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                color: "#222",
                                                background: "transparent",
                                                border: "none",
                                                borderBottom: "3px solid #3182F6",
                                                transition: "all 0.2s ease-in-out",
                                                cursor: "pointer"
                                            }}
                                        >
                                            거래상세
                                        </button>
                                    </div>

                                    <div style={{ padding: "10px" }}>
                                        <div>
                                            <PayInfo
                                                key={clickData?.id || ""}
                                                setMessage={setMessage}
                                                clickData={clickData}
                                                setReload={setReload}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='div-flex-1-4' style={{ backgroundColor: "#fff" }}>
                                    <div style={{
                                        display: "flex",
                                        gap: "10px",
                                        alignItems: "center",
                                        padding: "0 10px",
                                        borderBottom: "1px solid #E5E5E5"
                                    }}>
                                        <button
                                            className={`tab-btn active`}
                                            style={{
                                                padding: "12px 10px 8px",
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                color: "#222",
                                                background: "transparent",
                                                border: "none",
                                                borderBottom: "3px solid #3182F6",
                                                transition: "all 0.2s ease-in-out",
                                                cursor: "pointer"
                                            }}
                                        >
                                            거래확인서
                                        </button>
                                    </div>

                                    <div style={{ padding: "2px 0" }}>
                                        <div>
                                            <ReceiptInfo
                                                clickData={clickData}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            ""
                    }
                </div>
            </div>
        </div >
    )
}

function PayInfo({ clickData, setMessage, setReload }) {
    const { Rwidth, Rheight } = useWindowSize();
    const [isCancelling, setIsCancelling] = useState(false);
    const settlementInProgressRef = useRef(false);
    const brand = useSelector((state) => state.brand);
    const isInbiz = brand?.key === "baekma";

    let agent_fee = null;

    try {
        if (clickData?.agent_fee_data) {
            agent_fee = JSON.parse(clickData.agent_fee_data);
        }
    } catch (error) {
        console.error("agent_fee_data 파싱 실패:", error);
        agent_fee = null;
    }

    const formatFeeText = (data, indexFromLast) => {
        if (!data?.length) return '';

        const item = data[data.length - indexFromLast];
        const fee_amt = Number(item?.fee_amt);
        const fee = Number(item?.fee);

        return isNaN(fee_amt) || isNaN(fee)
            ? ''
            : `${changeNum(Math.round(fee_amt))} / ${fee.toFixed(2)}%`;
    };

    const onCancleData = async () => {
        // 이미 API 호출 중이면 재진입 방지
        if (isCancelling) return;

        if (window.confirm("결제를 취소하시겠습니까?") === true) {
            console.log(clickData);
            setIsCancelling(true);
            try {
                await axios.post(
                    process.env.REACT_APP_API + "/api/trx/cancel",
                    { id: clickData.id },
                    { withCredentials: true }
                ).then((response) => {
                    let tmp = response?.data;
                    console.log(tmp);
                    if (tmp?.code < 2000) {
                        setMessage({ msg: "성공했습니다." });
                        setReload((e) => !e);
                    } else {
                        setMessage({ msg: tmp?.msg ?? "실패했습니다." });
                    }
                }).catch((error) => {
                    console.error(error);
                });
            } finally {
                setIsCancelling(false);
            }
        }
    };

    const onSugiSettlement = async () => {
        // ref로 동기 재진입 방지 (모바일 연속 탭 대응)
        if (settlementInProgressRef.current) return;
        if (isCancelling) return;

        if (window.confirm("수기결제 건을 정산하시겠습니까?") === true) {
            console.log(clickData);
            settlementInProgressRef.current = true;
            setIsCancelling(true);
            const idempotencyKey =
                typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
                    ? crypto.randomUUID()
                    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
            try {
                await axios.post(
                    process.env.REACT_APP_API + "/api/transfer",
                    { trxId: clickData.id },
                    {
                        withCredentials: true,
                        headers: { "Idempotency-Key": idempotencyKey },
                    }
                ).then((response) => {
                    let tmp = response?.data;
                    console.log(tmp);
                    if (tmp?.code < 2000) {
                        setMessage({ msg: "성공했습니다." });
                    } else {
                        setMessage({ msg: tmp?.msg ?? "실패했습니다." });
                    }
                    setReload((e) => !e);
                }).catch((error) => {
                    console.error(error);
                });
            } finally {
                settlementInProgressRef.current = false;
                setIsCancelling(false);
            }
        }
    };

    // 숫자 포맷 변환 (예시로 가정)
    const changeNum = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    return (
        <div style={{ padding: "5px" }}>
            <div className="modal-dialog" style={{ top: "10%" }}>
                <div className=" marginTop30 modal_sty">
                    <div
                        style={{
                            padding: "0 0 0.5rem",
                            height: "645px",
                            overflowY: "auto",
                            fontSize: "12px",
                        }}
                    >
                        <div className="list-info-box">
                            <div className="box-gap">
                                <div
                                    className="gap"
                                    style={{ borderTop: "1px solid #e1e1e1" }}
                                >
                                    <ul>
                                        {/* 1) 주문번호 - single line in your original code */}
                                        <li>
                                            <div
                                                className="inner"
                                                style={{ width: "100%" }}
                                            >
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    주문번호
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >
                                                    {clickData?.order_id ?? ""}
                                                </span>
                                            </div>
                                        </li>

                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    거래아이디
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >
                                                    {clickData?.trx_id ?? ""}
                                                </span>
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    승인번호
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >
                                                    {clickData?.approval_id ?? ""}
                                                </span>
                                            </div>
                                        </li>

                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    거래일시
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >
                                                    {clickData?.trx_date ?? ""}
                                                </span>
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    승인금액
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >
                                                    {clickData?.total_amt
                                                        ? changeNum(Number(clickData?.total_amt))
                                                        : ""}
                                                </span>
                                            </div>
                                        </li>

                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    취소일시
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >
                                                    {clickData?.cancel_date ?? ""}
                                                </span>
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    취소금액
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >
                                                    {clickData?.cancel_price
                                                        ? changeNum(Number(clickData?.cancel_price))
                                                        : ""}
                                                </span>
                                            </div>
                                        </li>

                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    정산예정일
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >
                                                    {clickData?.settlement_date ?? ""}
                                                </span>
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    잔액
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >
                                                    {clickData?.total_amt
                                                        ? changeNum(Number(clickData?.total_amt))
                                                        : ""}
                                                </span>
                                            </div>
                                        </li>

                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    카드사
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >
                                                    {clickData?.card ?? ""}
                                                </span>
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    카드번호
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >
                                                    {clickData?.card_num ?? ""}
                                                </span>
                                            </div>
                                        </li>

                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    할부기간
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >
                                                    {clickData?.quota
                                                        ? `${clickData?.quota}개월`
                                                        : ""}
                                                </span>
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    구매자명
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >
                                                    {clickData?.buyer_nm ?? ""}
                                                </span>
                                            </div>
                                        </li>

                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    상품명
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >{clickData?.prd_nm ?? ""}</span>
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    전화번호
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >{clickData?.phone ?? ""}</span>
                                            </div>
                                        </li>

                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    지사 수수료
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >{formatFeeText(agent_fee, 1)}</span>
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    총판 수수료
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >{formatFeeText(agent_fee, 2)}</span>
                                            </div>
                                        </li>

                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    대리점 수수료
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >{formatFeeText(agent_fee, 3)}</span>
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    영업자1 수수료
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >{formatFeeText(agent_fee, 4)}</span>
                                            </div>
                                        </li>

                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    영업자2 수수료
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >{formatFeeText(agent_fee, 5)}</span>
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    영업자3 수수료
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >{formatFeeText(agent_fee, 6)}</span>
                                            </div>
                                        </li>

                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    총 수수료
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >{clickData?.fee ? changeNum(Number(clickData.fee)) + " / " : ""}{clickData?.cat_fee ? Number(clickData.cat_fee).toFixed(2) + "%" : ""}</span>
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "100px" }}
                                                >
                                                    정산예정금액
                                                </span>
                                                <span
                                                    className="right-text"
                                                    data-id="CARD_NO"
                                                    style={{
                                                        width: "calc(100% - 100px)",
                                                    }}
                                                >
                                                    {clickData?.settlement_amount
                                                        ? changeNum(
                                                            Number(clickData?.settlement_amount)
                                                        )
                                                        : ""}
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {clickData?.trx_id && (
                            <div
                                className="modal-footer"
                                style={{
                                    border: "none",
                                    paddingLeft: "0",
                                    paddingRight: "0",
                                    display: "flex",
                                    justifyContent: "space-between"
                                }}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <div>
                                        {
                                            !isInbiz &&
                                                clickData?.payment_type === "수기" &&
                                                clickData?.self_realtime === "N" &&
                                                clickData?.cancel_date == null
                                                ?
                                                clickData?.transfer_status == "SUCCESS"
                                                    ?
                                                    <button
                                                        type="button"
                                                        className="btn w-30 modal_btn btn-primary cancel_btn"
                                                        style={{ width: "60px", background: "green", color: "#fff" }}
                                                        disabled={true}
                                                    >
                                                        성공
                                                    </button>
                                                    :
                                                    clickData?.transfer_status == "PENDING"
                                                        ?
                                                        <button
                                                            type="button"
                                                            className="btn w-30 modal_btn btn-primary cancel_btn"
                                                            style={{ width: "60px", background: "gray", color: "#fff" }}
                                                            disabled={true}
                                                        >
                                                            진행중
                                                        </button>
                                                        :
                                                        clickData?.transfer_status == "FAILED"
                                                            ?
                                                            <button
                                                                type="button"
                                                                className="btn w-30 modal_btn btn-primary cancel_btn"
                                                                style={{ width: "60px", background: "red", color: "#fff" }}
                                                                disabled={true}
                                                            >
                                                                실패
                                                            </button>
                                                            :
                                                            <button
                                                                type="button"
                                                                className="btn w-30 modal_btn btn-primary cancel_btn"
                                                                style={{ width: "60px" }}
                                                                disabled={
                                                                    (clickData?.payment_type === "수기" &&
                                                                        clickData?.self_realtime === "N" &&
                                                                        clickData?.cancel_date == null
                                                                        ? false
                                                                        : true) || isCancelling
                                                                }
                                                                onClick={() => {
                                                                    if (
                                                                        !isCancelling &&
                                                                        clickData?.payment_type === "수기" &&
                                                                        clickData?.self_realtime === "N" &&
                                                                        clickData?.cancel_date == null
                                                                    ) {
                                                                        onSugiSettlement();
                                                                    }
                                                                }}
                                                            >
                                                                정산
                                                            </button>
                                                :
                                                <div></div>
                                        }
                                    </div>
                                    {
                                        !isInbiz &&
                                            clickData?.payment_type === "수기" &&
                                            clickData?.self_realtime === "N" &&
                                            clickData?.cancel_date == null
                                            ?
                                            <div style={{ fontSize: "12px", color: "red" }}>* 처리 중으로 나올 시 최소 5분의 시간이 소요됩니다. </div>
                                            :
                                            ""
                                    }
                                </div>
                                <button
                                    type="button"
                                    className="btn w-30 modal_btn btn-danger cancel_btn"
                                    disabled={
                                        (clickData?.payment_type === "수기" &&
                                            clickData?.cancel_date == null
                                            ? false
                                            : true) || isCancelling
                                    }
                                    onClick={() => {
                                        if (
                                            !isCancelling &&
                                            clickData?.payment_type === "수기" &&
                                            clickData?.cancel_date == null
                                        ) {
                                            onCancleData();
                                        }
                                    }}
                                >
                                    {(() => {
                                        if (
                                            clickData?.payment_type === "수기" &&
                                            clickData?.cancel_date == null
                                        )
                                            return "결제취소";
                                        if (
                                            clickData?.payment_type === "수기" &&
                                            clickData?.cancel_date
                                        )
                                            return "결제취소완료";
                                        return "취소불가";
                                    })()}
                                </button>
                            </div>
                        )}

                        {
                            clickData?.transfer_status == "SUCCESS" ||
                                clickData?.transfer_status == "PENDING" ||
                                clickData?.transfer_status == "FAILED"
                                ?
                                <div className="list-info-box">
                                    <div className="box-gap">
                                        <div
                                            className="gap"
                                            style={{ borderTop: "1px solid #e1e1e1" }}
                                        >
                                            <ul>
                                                {/* 1) 주문번호 - single line in your original code */}
                                                <li>
                                                    <div
                                                        className="inner"
                                                        style={{ width: "100%" }}
                                                    >
                                                        <span
                                                            className="left-text"
                                                            style={{ width: "100px" }}
                                                        >
                                                            상태 메세지
                                                        </span>
                                                        <span
                                                            className="right-text"
                                                            data-id="CARD_NO"
                                                            style={{
                                                                width: "calc(100% - 100px)",
                                                            }}
                                                        >
                                                            {clickData?.transfer_result_msg === "0021" ? "이체 완료" : clickData?.transfer_result_msg}
                                                        </span>
                                                    </div>
                                                </li>

                                                <li className='mobile'>
                                                    <div className="inner">
                                                        <span
                                                            className="left-text"
                                                            style={{ width: "100px" }}
                                                        >
                                                            이체금액
                                                        </span>
                                                        <span
                                                            className="right-text"
                                                            data-id="CARD_NO"
                                                            style={{
                                                                width: "calc(100% - 100px)",
                                                            }}
                                                        >
                                                            {clickData?.transfer_amount ? changeNum(Number(clickData?.transfer_amount)) : ""}
                                                        </span>
                                                    </div>
                                                    <div className="inner">
                                                        <span
                                                            className="left-text"
                                                            style={{ width: "100px" }}
                                                        >
                                                            상태
                                                        </span>
                                                        <span
                                                            className="right-text"
                                                            data-id="CARD_NO"
                                                            style={{
                                                                width: "calc(100% - 100px)",
                                                            }}
                                                        >
                                                            {clickData?.transfer_result_code === "VTIM" ? "처리중" : clickData?.transfer_result_code === "0011" ? "처리중" : clickData?.transfer_result_code === "0000" ? "성공" : "실패"}
                                                        </span>
                                                    </div>
                                                </li>

                                                <li className='mobile'>
                                                    <div className="inner">
                                                        <span
                                                            className="left-text"
                                                            style={{ width: "100px" }}
                                                        >
                                                            고유번호
                                                        </span>
                                                        <span
                                                            className="right-text"
                                                            data-id="CARD_NO"
                                                            style={{
                                                                width: "calc(100% - 100px)",
                                                            }}
                                                        >
                                                            {clickData?.transfer_telegram_no ?? ""}
                                                        </span>
                                                    </div>
                                                    <div className="inner">
                                                        <span
                                                            className="left-text"
                                                            style={{ width: "100px" }}
                                                        >
                                                            이체 시간
                                                        </span>
                                                        <span
                                                            className="right-text"
                                                            data-id="CARD_NO"
                                                            style={{
                                                                width: "calc(100% - 100px)",
                                                            }}
                                                        >
                                                            {clickData?.transfer_at ?? ""}
                                                        </span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                :
                                ""
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

function ReceiptInfo({ clickData }) {
    const { Rwidth, Rheight } = useWindowSize();

    const divRef = useRef(null);

    const handleCapture = async () => {
        if (!divRef.current) return;

        const canvas = await html2canvas(divRef.current);

        // ✅ 이미지 저장
        const link = document.createElement('a');
        link.download = `${clickData.co_nm}_${clickData.trx_id}.png`;
        link.href = canvas.toDataURL();
        link.click();

        // ✅ 클립보드 복사
        canvas.toBlob(async (blob) => {
            try {
                await navigator.clipboard.write([
                    new ClipboardItem({
                        [blob.type]: blob,
                    }),
                ]);
                // alert('이미지가 클립보드에 복사되었고, 저장도 완료되었습니다!');
            } catch (err) {
                console.error('클립보드 복사 실패:', err);
                // alert('이미지 저장은 성공했지만, 클립보드 복사는 실패했어요 😢');
            }
        });
    };

    return (
        <div>
            {/* <div id="receipt-modal" className="modal" tabindex="-1" > */}
            <div className="modal-dialog">
                <div className="marginTop30 modal_sty type-receipt receipt-modal-content">
                    <form id="modal-form">
                        <div className="modal-body receipt-modal-body" style={{ padding: "0" }}>
                            <div className="box-sales" id="box-sales" style={{ padding: Rwidth >= 640 ? '1rem 1rem .5rem' : '1rem 0rem .5rem' }} ref={divRef} >
                                {
                                    // 취소시 취소 이미지
                                    clickData?.cancelType
                                        ?
                                        <div className="box-result" style={{ top: "50%", position: "absolute" }}>
                                            <div className="inner">
                                                <img src="/img/bg_cancel.png" alt="취소" />
                                            </div>
                                        </div>
                                        :
                                        ""
                                }
                                <div id="header">
                                    <h1><img src="/img/win_logo_top.png" style={{ height: "20px" }} alt="앤트페이" /></h1>
                                    <h2 style={{ fontSize: ".9rem" }}>신용카드 매출전표</h2>
                                </div>
                                <div className="list-info-box" style={{ marginBottom: "15px" }}>
                                    <div className="box-gap">
                                        <div className="gap">
                                            <div className="tt"><h3>결제정보</h3></div>
                                            <ul>
                                                <li>
                                                    <div className="inner">
                                                        <div className="left-text font9" style={{ width: "80px" }}>결제수단</div>
                                                        <div className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">{clickData?.payment_service ?? ""}</div>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>거래상태</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NAME">{clickData?.state ? clickData?.state == 1 ? "승인" : "취소" : ""}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>거래일시</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">{clickData?.trx_date ?? ""}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>취소일시</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NAME">{clickData?.cancel_date ?? ""}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>결제카드</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">{clickData?.card ?? ""}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>카드번호</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NAME">{clickData?.card_num ?? ""}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>할부개월</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">{clickData?.quota ? clickData?.quota == "00" ? "일시불" : `${clickData?.quota ?? 0}개월` : ""}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>{clickData?.cancel_approval_id ? "취소번호" : "승인번호"}</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NAME">{clickData?.cancel_approval_id ? clickData?.cancel_approval_id : clickData.approval_id}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>{clickData?.cancel_approval_id ? "취소금액" : "승인금액"}</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">{clickData?.total_amt ? changeNum(Number(clickData?.total_amt ?? 0)) : ""}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>과세금액</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NAME">
                                                            {clickData?.total_amt ? clickData?.cancel_approval_id ? 0 : changeNum(Math.floor(Number(clickData?.total_amt ?? 0)) - Math.floor(Number(clickData?.total_amt ?? 0) / 11)) : ""}
                                                        </span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>구매자명</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">{clickData?.buyer_nm ?? ''}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>부가세</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NAME">
                                                            {clickData?.total_amt ? clickData?.cancel_approval_id ? 0 : changeNum(Math.floor(Number(clickData?.total_amt ?? 0) / 11)) : ""}
                                                        </span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>상품명</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">{clickData?.prd_nm ?? ''}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>면세금액</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NAME"></span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="infoFooter">
                                    ＊ 부가세법 제46조에 따라 신용카드 매출전표를 이용하여 매입세액 공제가 가능합니다.(동법 제 33조 2항에 근거하여 신용카드 매출전표를 발행한 경우에는 세금계산서를 발급하지 아니합니다.)
                                    <div className="box-btn">
                                    </div>
                                </div>
                            </div>
                            <div className="box-sales" id="box-sales" style={{ padding: Rwidth >= 640 ? '0rem 1rem .5rem' : '0rem 0rem .5rem' }}>
                                <div className="list-info-box" style={{ marginBottom: "15px" }}>
                                    <div className="box-gap">
                                        <div className="gap">
                                            <div className="tt"><h3>공급자 정보</h3></div>
                                            <ul>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>상호</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">{clickData?.co_nm ?? ""}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>사업자번호</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NAME">{clickData?.co_no ?? ""}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>대표자명</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">{clickData?.boss_nm ?? ""}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>연락처</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NAME">{clickData?.phone ?? ""}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text font9" style={{ width: "80px" }}>주소</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">{clickData?.co_addr ?? ""}</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="list-info-box" style={{ marginBottom: "15px" }}>
                                    <div className="box-gap">
                                        <div className="gap">
                                            <div className="tt"><h3>결제 대행사 정보</h3></div>
                                            <ul>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>상호</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">(주)윈글로벌페이</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>사업자번호</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NAME">648-86-00577</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text font9" style={{ width: "80px" }}>대표자명</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">이학찬</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text font9" style={{ width: "80px" }}>주소</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">경기도 하남시 조정대로 45 348호(풍산동, 미사센텀비즈)</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>상호</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">(주)코페이</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>사업자번호</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NAME">206-81-90716</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text font9" style={{ width: "80px" }}>대표자명</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">채수철</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text font9" style={{ width: "80px" }}>주소</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">서울 성동구 성수일로 77 서울숲IT밸리 608-611호</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="infoFooter">
                                    ＊ 부가세법 제46조에 따라 신용카드 매출전표를 이용하여 매입세액 공제가 가능합니다.(동법 제 33조 2항에 근거하여 신용카드 매출전표를 발행한 경우에는 세금계산서를 발급하지 아니합니다.)
                                    <div className="box-btn">
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </form>
                    {
                        clickData?.trx_id
                            ?
                            <div className="modal-footer" style={{ border: "none", padding: Rwidth >= 640 ? '0 1rem .75rem 0' : '0 0 .75rem 0' }}>
                                <button id="receipt_print_btn" type="button" className="btn"
                                    style={{ marginRight: "3px", backgroundColor: "#d2e4fb", fontWeight: "600", width: "70px" }}
                                    onClick={handleCapture}>
                                    저장</button>
                            </div>
                            :
                            ""
                    }
                </div>
            </div>
        </div>
    )
}

// function ReceiptInfo({ clickData }) {
//     const divRef = useRef(null);

//     // 이미지 저장 + 클립보드 복사
//     const handleCapture = async () => {
//         if (!divRef.current) return;

//         const canvas = await html2canvas(divRef.current);

//         // 1) 이미지로 저장
//         const link = document.createElement('a');
//         link.download = 'aocn.png';
//         link.href = canvas.toDataURL();
//         link.click();

//         // 2) 클립보드 복사
//         canvas.toBlob(async (blob) => {
//             try {
//                 await navigator.clipboard.write([
//                     new ClipboardItem({
//                         [blob.type]: blob,
//                     }),
//                 ]);
//                 alert('이미지가 클립보드에 복사되었고, 저장도 완료되었습니다!');
//             } catch (err) {
//                 console.error('클립보드 복사 실패:', err);
//                 alert('이미지 저장은 성공했지만, 클립보드 복사는 실패했어요 😢');
//             }
//         });
//     };

//     // 일관된 폭을 위한 labelWidth 정의
//     const labelWidth = '80px'; // 왼쪽 레이블 폭

//     return (
//         <div style={{ padding: '5px' }}>
//             <div className="modal-dialog">
//                 {/* 실제 종이 영수증 느낌의 래퍼 */}
//                 <div
//                     className="receipt-paper"
//                     ref={divRef}
//                     style={{
//                         width: '350px',
//                         margin: '0 auto',
//                         padding: '20px',
//                         fontFamily: "'Nanum Gothic Coding', monospace",
//                         backgroundColor: '#fff',
//                         border: '1px dashed #999',
//                     }}
//                 >
//                     <div id="header" style={{ borderBottom: "1px solid #d5d5d5", paddingBottom: "20px" }}>
//                         <h2 style={{ fontSize: ".9rem" }}>신용카드 매출전표</h2>
//                         <h1><img src="/img/win_logo_top.png" style={{ height: "20px" }} alt="앤트페이" /></h1>
//                     </div>
//                     {/* 상단 상호 + 매장정보 */}
//                     <div style={{ textAlign: 'center', margin: '10px 0' }}>
//                         <strong style={{ fontSize: '1.1rem' }}>
//                             {clickData?.co_nm ?? '점포명'}
//                         </strong>
//                     </div>

//                     {/* 사업자/대표자 정보 */}
//                     <div style={{ fontSize: '0.8rem', margin: '10px 0' }}>
//                         <div style={{ display: 'flex', marginBottom: '3px' }}>
//                             <div style={{ width: labelWidth }}>대표자</div>
//                             <div style={{ flex: '1' }}>{clickData?.boss_nm ?? ''}</div>
//                         </div>
//                         <div style={{ display: 'flex', marginBottom: '3px' }}>
//                             <div style={{ width: labelWidth }}>사업자번호</div>
//                             <div style={{ flex: '1' }}>{clickData?.co_no ?? ''}</div>
//                         </div>
//                         <div style={{ display: 'flex', marginBottom: '3px' }}>
//                             <div style={{ width: labelWidth }}>전화번호</div>
//                             <div style={{ flex: '1' }}>{clickData?.phone ?? ''}</div>
//                         </div>
//                         <div style={{ display: 'flex', marginBottom: '3px' }}>
//                             <div style={{ width: labelWidth }}>주소</div>
//                             <div style={{ flex: '1' }}>{clickData?.co_addr ?? ''}</div>
//                         </div>
//                         <div style={{ display: 'flex', marginBottom: '3px' }}>
//                             <div style={{ width: labelWidth }}>판매일자</div>
//                             <div style={{ flex: '1' }}>{clickData?.trx_date ?? ''}</div>
//                         </div>
//                     </div>

//                     {/* 구분선 */}
//                     <hr style={{ border: '0', borderBottom: '1px dashed #999' }} />

//                     {/* 결제금액 */}
//                     <div style={{ fontSize: '0.8rem', margin: '15px 0' }}>
//                         <div
//                             style={{
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 margin: '5px 0',
//                                 fontSize: '1.2rem',
//                                 fontWeight: 'bold',
//                             }}
//                         >
//                             <span>결제금액</span>
//                             <span>
//                                 {clickData?.total_amt
//                                     ? changeNum(Number(clickData?.total_amt ?? 0))
//                                     : ''}
//                                 원
//                             </span>
//                         </div>
//                         <div
//                             style={{
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 marginBottom: '3px',
//                             }}
//                         >
//                             <span>공급가액</span>
//                             <span>
//                                 {clickData?.total_amt
//                                     ? clickData?.cancel_approval_id
//                                         ? 0
//                                         : changeNum(
//                                             Math.floor(Number(clickData?.total_amt ?? 0)) -
//                                             Math.floor(
//                                                 (Number(clickData?.total_amt ?? 0) * 0.1) /
//                                                 1.1
//                                             )
//                                         )
//                                     : ''}
//                                 원
//                             </span>
//                         </div>
//                         <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                             <span>부가세액</span>
//                             <span>
//                                 {clickData?.total_amt
//                                     ? clickData?.cancel_approval_id
//                                         ? 0
//                                         : changeNum(
//                                             Math.floor(
//                                                 Number(clickData?.total_amt ?? 0) / 11
//                                             )
//                                         )
//                                     : ''}
//                                 원
//                             </span>
//                         </div>
//                     </div>

//                     {/* 구분선 */}
//                     <hr style={{ border: '0', borderBottom: '1px dashed #999' }} />

//                     {/* 카드정보 */}
//                     <div style={{ fontSize: '0.8rem', margin: '10px 0' }}>
//                         <div style={{ display: 'flex', marginBottom: '3px' }}>
//                             <div style={{ width: labelWidth }}>카드번호</div>
//                             <div style={{ flex: '1' }}>{clickData?.card_num ?? ''}</div>
//                         </div>
//                         <div style={{ display: 'flex', marginBottom: '3px' }}>
//                             <div style={{ width: labelWidth }}>종류</div>
//                             <div style={{ flex: '1' }}>{clickData?.payment_type ?? ''}</div>
//                         </div>
//                         <div style={{ display: 'flex', marginBottom: '3px' }}>
//                             <div style={{ width: labelWidth }}>구분</div>
//                             <div style={{ flex: '1' }}>
//                                 {clickData?.quota === '00'
//                                     ? '일시불'
//                                     : clickData?.quota ?? ''}
//                             </div>
//                         </div>
//                         <div style={{ display: 'flex', marginBottom: '3px' }}>
//                             <div style={{ width: labelWidth }}>승인일자</div>
//                             <div style={{ flex: '1' }}>{clickData?.trx_date ?? ''}</div>
//                         </div>
//                         <div style={{ display: 'flex', marginBottom: '3px' }}>
//                             <div style={{ width: labelWidth }}>취소일자</div>
//                             <div style={{ flex: '1' }}>{clickData?.cancel_date ?? ''}</div>
//                         </div>
//                         <div style={{ display: 'flex', marginBottom: '3px' }}>
//                             <div style={{ width: labelWidth }}>승인번호</div>
//                             <div style={{ flex: '1' }}>{clickData?.approval_id ?? ''}</div>
//                         </div>
//                         <div style={{ display: 'flex', marginBottom: '3px' }}>
//                             <div style={{ width: labelWidth }}>카드사</div>
//                             <div style={{ flex: '1' }}>{clickData?.card ?? ''}</div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* 저장 버튼 */}
//                 <div
//                     style={{
//                         display: 'flex',
//                         justifyContent: 'center',
//                         marginTop: '12px',
//                     }}
//                 >
//                     <button
//                         type="button"
//                         className="btn"
//                         onClick={handleCapture}
//                         style={{
//                             backgroundColor: '#d2e4fb',
//                             fontWeight: '600',
//                             padding: '5px 10px',
//                         }}
//                     >
//                         저장
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// }

function MobileReceiptInfo({ setModal, clickData }) {
    const { Rwidth, Rheight } = useWindowSize();
    const divRef = useRef(null);

    const handleCapture = async () => {
        if (!divRef.current) return;

        const canvas = await html2canvas(divRef.current);

        // ✅ 이미지 저장
        const link = document.createElement('a');
        link.download = `${clickData.co_nm}_${clickData.trx_id}.png`;
        link.href = canvas.toDataURL();
        link.click();

        // ✅ 클립보드 복사
        canvas.toBlob(async (blob) => {
            try {
                await navigator.clipboard.write([
                    new ClipboardItem({
                        [blob.type]: blob,
                    }),
                ]);
                alert('이미지가 클립보드에 복사되었고, 저장도 완료되었습니다!');
            } catch (err) {
                console.error('클립보드 복사 실패:', err);
                alert('이미지 저장은 성공했지만, 클립보드 복사는 실패했어요 😢');
            }
        });
    };
    return (
        <div id="receipt-modal" className="modal" tabindex="-1" >
            <div className="modal-dialog" style={{ padding: Rwidth > 767 ? "2rem" : "1rem .75rem", maxWidth: "500px" }}>
                <div className="modal-content marginTop30 modal_sty type-receipt receipt-modal-content">
                    <div className="modal-header receipt-modal-header" style={{ border: "none", padding: "0" }}>
                        <h2 className="font-medium text-base mr-auto modal_title_sty">결제 정보</h2>
                        <button className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty" aria-expanded="false" data-tw-toggle="dropdown" onClick={() => setModal(false)}>
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="plus" className="lucide lucide-plus w-4 h-4" data-lucide="plus">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <form id="modal-form" ref={divRef}>
                        <div className="modal-body receipt-modal-body">
                            <div className="box-sales" id="box-sales" style={{ padding: "1rem 0" }}>
                                {
                                    // 취소시 취소 이미지
                                    clickData?.cancelType
                                        ?
                                        <div className="box-result" style={{ top: "50%", position: "absolute" }}>
                                            <div className="inner">
                                                <img src="/img/bg_cancel.png" alt="취소" />
                                            </div>
                                        </div>
                                        :
                                        ""
                                }
                                <div id="header">
                                    <h1><img src="/img/win_logo_top.png" style={{ height: "20px" }} alt="앤트페이" /></h1>
                                    <h2 style={{ fontSize: ".9rem", fontWeight: "bold", fontFamily: "Roboto" }}>신용카드 매출전표</h2>
                                </div>
                                <div className="list-info-box">
                                    <div className="box-gap">
                                        <div className="gap">
                                            <div className="tt"><h3>결제정보</h3></div>
                                            <ul>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>결제수단</span>
                                                        <span className="right-text font9" data-id="CARD_NO" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>{clickData.payment_service}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>거래상태</span>
                                                        <span className="right-text font9" data-id="CARD_NAME" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>{clickData.state == 1 ? "승인" : "취소"}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>거래일시</span>
                                                        <span className="right-text font9" data-id="CARD_NO" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>{clickData.trx_date}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>취소일시</span>
                                                        <span className="right-text font9" data-id="CARD_NAME" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>{clickData.cancel_date}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>결제카드</span>
                                                        <span className="right-text font9" data-id="CARD_NO" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>{clickData.card}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>카드번호</span>
                                                        <span className="right-text font9" data-id="CARD_NAME" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>{clickData.card_num}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>할부개월</span>
                                                        <span className="right-text font9" data-id="CARD_NO" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>{clickData.quota == "00" ? "일시불" : `${clickData.quota}개월`}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>{clickData?.cancel_approval_id ? "취소번호" : "승인번호"}</span>
                                                        <span className="right-text font9" data-id="CARD_NAME" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>{clickData?.cancel_approval_id ? clickData?.cancel_approval_id : clickData.approval_id}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>{clickData?.cancel_approval_id ? "취소금액" : "승인금액"}</span>
                                                        <span className="right-text font9" data-id="CARD_NO" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>{changeNum(Number(clickData.total_amt))}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>과세금액</span>
                                                        <span className="right-text font9" data-id="CARD_NAME" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>
                                                            {clickData?.cancel_approval_id ? 0 : changeNum(Math.floor(Number(clickData.total_amt)) - Math.floor(Number(clickData.total_amt) / 11))}
                                                        </span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>구매자명</span>
                                                        <span className="right-text font9" data-id="CARD_NO" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>{clickData.buyer_nm}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>부가세</span>
                                                        <span className="right-text font9" data-id="CARD_NAME" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>
                                                            {clickData?.cancel_approval_id ? 0 : changeNum(Math.floor(Number(clickData.total_amt) / 11))}
                                                        </span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>상품명</span>
                                                        <span className="right-text font9" data-id="CARD_NO" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>{clickData.prd_nm}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>면세금액</span>
                                                        <span className="right-text font9" data-id="CARD_NAME" style={{ padding: Rwidth > 767 ? "" : "5px 0 5px 5px" }}>{0}</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="list-info-box" style={{ marginBottom: "15px" }}>
                                    <div className="box-gap">
                                        <div className="gap">
                                            <div className="tt"><h3>공급자 정보</h3></div>
                                            <ul>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>상호</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">{clickData?.co_nm ?? ""}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>사업자번호</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NAME">{clickData?.co_no ?? ""}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>대표자명</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">{clickData?.boss_nm ?? ""}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>연락처</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NAME">{clickData?.phone ?? ""}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text font9" style={{ width: "80px" }}>주소</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">{clickData?.co_addr ?? ""}</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="list-info-box" style={{ marginBottom: "15px" }}>
                                    <div className="box-gap">
                                        <div className="gap">
                                            <div className="tt"><h3>결제 대행사 정보</h3></div>
                                            <ul>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>상호</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">(주)윈글로벌페이</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>사업자번호</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NAME">648-86-00577</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text font9" style={{ width: "80px" }}>대표자명</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">이학찬</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text font9" style={{ width: "80px" }}>주소</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">경기도 하남시 조정대로 45 348호(풍산동, 미사센텀비즈)</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>상호</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">(주)코페이</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text font9" style={{ width: "80px" }}>사업자번호</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NAME">206-81-90716</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text font9" style={{ width: "80px" }}>대표자명</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">채수철</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner" style={{ width: "100%" }}>
                                                        <span className="left-text font9" style={{ width: "80px" }}>주소</span>
                                                        <span className="right-text font9" style={{ width: "calc(100% - 82px)" }} data-id="CARD_NO">서울 성동구 성수일로 77 서울숲IT밸리 608-611호</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="infoFooter">
                                    ＊ 부가세법 제46조에 따라 신용카드 매출전표를 이용하여 매입세액 공제가 가능합니다.(동법 제 33조 2항에 근거하여 신용카드 매출전표를 발행한 경우에는 세금계산서를 발급하지 아니합니다.)
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="modal-footer" style={{ border: "none" }}>
                        <button id="receipt_print_btn" type="button" className="btn"
                            style={{ marginRight: "3px", backgroundColor: "#d2e4fb", fontWeight: "600" }}
                            onClick={handleCapture}
                        >저장</button>
                        <button type="button" className="btn w-20 modal_btn receipt_close_btn" onClick={() => setModal(false)}>닫기</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

function SearchInfo({ setModal, setReload, formData, handleChangeFormData }) {

    const onSubmit = async () => {
        setReload(e => !e)
        setModal(false)
    }

    return (
        <div id="submerchants-modal" class="modal show_modal" tabindex="-1">
            <div className="modal-dialog">
                <div className="modal-content marginTop30 modal_sty">
                    <div className="modal-header">
                        <h2 className="font-medium text-base mr-auto modal_title_sty">검색조건</h2>
                        <button type="button" className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty" aria-expanded="false" data-tw-toggle="dropdown" onClick={() => setModal(false)}>
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="plus" className="lucide lucide-plus w-4 h-4" data-lucide="plus">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <div style={{ padding: '0 0 0.5rem', overflowY: "auto" }}>
                        <form
                            id="modal-form"
                            className="modal-body grid grid-cols-12 gap-4 gap-y-3"
                            style={{ padding: "1rem 0 1.5rem 0" }}
                        >
                            {/* 조회기준 */}
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="조회기준" className="form-label">
                                    조회기준
                                </label>
                                <select
                                    id="조회기준"
                                    name="조회기준"
                                    className="form-select w-full"
                                    value={formData.조회기준}
                                    onChange={handleChangeFormData}
                                >
                                    <option value="1">승인일자</option>
                                    <option value="2">취소일자</option>
                                </select>
                            </div>

                            {/* 거래상태 */}
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="거래상태" className="form-label">
                                    거래상태
                                </label>
                                <select
                                    id="거래상태"
                                    name="거래상태"
                                    className="form-select w-full"
                                    value={formData.거래상태}
                                    onChange={handleChangeFormData}
                                >
                                    <option value="">전체</option>
                                    <option value="1">승인</option>
                                    <option value="2">매입전취소</option>
                                    <option value="3">매입후취소</option>
                                </select>
                            </div>

                            {/* 결제구분 */}
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="결제구분" className="form-label">
                                    결제구분
                                </label>
                                <select
                                    id="결제구분"
                                    name="결제구분"
                                    className="form-select w-full"
                                    value={formData.결제구분}
                                    onChange={handleChangeFormData}
                                >
                                    <option value="">전체</option>
                                    <option value="수기">수기</option>
                                    <option value="단말기">단말기</option>
                                </select>
                            </div>

                            {/* 에이전트명 */}
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="에이전트명" className="form-label">
                                    에이전트명
                                </label>
                                <input
                                    id="에이전트명"
                                    name="에이전트명"
                                    type="text"
                                    className="form-control"
                                    value={formData.에이전트명}
                                    onChange={handleChangeFormData}
                                />
                            </div>

                            {/* 에이전트아이디 */}
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="에이전트아이디" className="form-label">
                                    에이전트아이디
                                </label>
                                <input
                                    id="에이전트아이디"
                                    name="에이전트아이디"
                                    type="text"
                                    className="form-control"
                                    value={formData.에이전트아이디}
                                    onChange={handleChangeFormData}
                                />
                            </div>

                            {/* 상호 */}
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="상호" className="form-label">
                                    상호
                                </label>
                                <input
                                    id="상호"
                                    name="상호"
                                    type="text"
                                    className="form-control"
                                    value={formData.상호}
                                    onChange={handleChangeFormData}
                                />
                            </div>

                            {/* MID */}
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="MID" className="form-label">
                                    MID
                                </label>
                                <input
                                    id="MID"
                                    name="MID"
                                    type="text"
                                    className="form-control"
                                    value={formData.MID}
                                    onChange={handleChangeFormData}
                                />
                            </div>

                            {/* 구매자명 */}
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="구매자명" className="form-label">
                                    구매자명
                                </label>
                                <input
                                    id="구매자명"
                                    name="구매자명"
                                    type="text"
                                    className="form-control"
                                    value={formData.구매자명}
                                    onChange={handleChangeFormData}
                                />
                            </div>

                            {/* 주문번호 */}
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="주문번호" className="form-label">
                                    주문번호
                                </label>
                                <input
                                    id="주문번호"
                                    name="주문번호"
                                    type="text"
                                    className="form-control"
                                    value={formData.주문번호}
                                    onChange={handleChangeFormData}
                                />
                            </div>

                            {/* 상품명 */}
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="상품명" className="form-label">
                                    상품명
                                </label>
                                <input
                                    id="상품명"
                                    name="상품명"
                                    type="text"
                                    className="form-control"
                                    value={formData.상품명}
                                    onChange={handleChangeFormData}
                                />
                            </div>

                            {/* 연락처 */}
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="연락처" className="form-label">
                                    연락처
                                </label>
                                <input
                                    id="연락처"
                                    name="연락처"
                                    type="text"
                                    className="form-control"
                                    value={formData.연락처}
                                    onChange={handleChangeFormData}
                                />
                            </div>

                            {/* 승인번호 */}
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="승인번호" className="form-label">
                                    승인번호
                                </label>
                                <input
                                    id="승인번호"
                                    name="승인번호"
                                    type="text"
                                    className="form-control"
                                    value={formData.승인번호}
                                    onChange={handleChangeFormData}
                                />
                            </div>

                            {/* TID */}
                            <div className="col-span-12 sm:col-span-6">
                                <label htmlFor="TID" className="form-label">
                                    TID
                                </label>
                                <input
                                    id="TID"
                                    name="TID"
                                    type="text"
                                    className="form-control"
                                    value={formData.TID}
                                    onChange={handleChangeFormData}
                                />
                            </div>
                        </form>

                    </div>

                    <div className="modal-footer">
                        <button type="submit" className="btn btn-primary w-20 reg_btn" onClick={() => onSubmit()}>검색</button>
                        <input type="button" className="btn btn-primary w-20 close_btn" onClick={() => setModal(false)} style={{ backgroundColor: 'darkred', marginLeft: '10px', border: 'none' }} value="닫기" />
                    </div>
                </div>
            </div>
        </div>
    )
}

const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = '거래내역';

    const headerRow = [
        "NO", "상호", "MID", "승인번호", "거래일시", "취소일시", "거래상태", "매입금액",
        "정산수수료", "정산금액",
        "결제서비스", "결제구분", "구매자명", "카드", "카드번호", "할부", "상품명", "거래번호"
    ];

    const bodyRows = excelData.map((data) => ([
        data.NO, data.상호, data.MID, data.승인번호, data.거래일시, data.취소일시, data.거래상태,
        Number(data.승인금액), Number(data.정산수수료), Number(data.정산금액), data.결제서비스, data.결제구분, data.구매자명, data.카드,
        data.카드번호, data.할부, data.상품명, data.거래번호
    ]));

    const sheetData = [headerRow, ...bodyRows];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws['!cols'] = Array(headerRow.length).fill({ wpx: 100 });

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelBuffer], { type: excelFileType });

    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default Paylist